import React from 'react';
import { Typography, Grid, Paper, Theme } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { createStyles } from 'app/util/styles';
import { withTranslation } from 'react-i18next';
import { getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { PrequalSummaryFields } from 'app/components/PrequalSummary/PrequalSummaryFields';
import { FormType } from '@lenderful/domain';

const styles = (theme: Theme) => createStyles({
  dialogBlock: {
    background: theme.palette.secondary.main,
    padding   : '1.25rem 1rem',
  },
  buttonsWrapper: {
    marginTop: '1rem',
  },
});

const PrequalSummaryComponent: any = withStyles(({ ...props }: any) => {
  const { t } = props;

  return (
    <Grid container>
      <Grid item xs={12}>
        <Paper elevation={0} classes={{ root: 'formWrapper' }}>
          <Typography variant="h6" classes={{ h6: 'withTopSection noMarginBottom' }}>
            {t('prequalSummary.subtitle', { defaultValue: 'Your Pre-Qualification Summary' })}
          </Typography>
          <PrequalSummaryFields values={props.values} paragraphText={null} />
        </Paper>
      </Grid>
    </Grid>
  );
}, styles);

const mapStateToProps = (state, ownProps) => {
  return {
    rate : state.rates[0],
    values : getFormValues(FormType.AUTO_PREQUAL)(state),
    ...ownProps,
  };
};

export const PrequalSummary = connect(
  mapStateToProps,
  null,
)(withTranslation()(PrequalSummaryComponent));
